module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_sentrert logo_neg(hvit).a36f10a0.pdf";